<template>
    <div class="partner-institutions">
        <div class="banner-head">
            <div class="introduction-box">
                <div style="height: 230px;"></div>
                <div class="title">启乘无忧</div>
                <div class="cooperative-text">与全国超60所高校建立了深度合作</div>
                <div style="height: 37px;"></div>
                <div class="cooperative-address">覆盖湖北、湖南、河北、河南、云南、四川等10+个省份</div>
            </div>
        </div>
        <!--合作学校-->
        <div class="cooperation-school">
            <div class="school-list" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-1200">
                <div v-for="(item, index) in logs">
                    <div class="school-itme" v-if="index != schoolBid" @mouseenter="handleMouseEnter(index)" >
                        <img :src="item.url" style="width: 126px; height: 126px;" />
                        <div style="height: 14px;"></div>
                        <div class="school-name">{{ item.schoolName }}</div>
                    </div>
                    <div class="school-itme-active" v-if="index == schoolBid"  @mouseleave="handleMouseLeave">
                        <div class="school">
                            <div class="school-content">
                                <img :src="item.url" style="width: 116px; height: 116px; opacity: 0.5;"/>
                                <div class="btn" @click="enter(item.pathUrl)">进入官网</div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="school-itme">
                    <div class="school-name">敬请期待</div>
                </div>
            </div>
        </div>
        <contact-us />
    </div>
</template>

<script>
import contactUs from '../../components/ContactUs/contactUs.vue'
export default {
    name: 'PartnerInstitutions',
    components: {
        contactUs
    },
    mounted() {
        window.scrollTo({
            top: 0,
        })
    },
    data() {
        return {
            schoolBid: -1,
            logs: [
                {
                    url: '../../../static/logo/logo1.png',
                    schoolName: '河北石油职业技术大学',
                    pathUrl: 'https://www.hebpu.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo2.png',
                    schoolName: '江汉大学',
                    pathUrl: 'https://www.jhun.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo3.png',
                    schoolName: '淮南师范学院',
                    pathUrl: 'https://www.hnnu.edu.cn/main.htm'
                },
                {
                    url: '../../../static/logo/logo4.png',
                    schoolName: '湖北科技学院',
                    pathUrl: 'https://www.hbust.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo5.png',
                    schoolName: '河南工业大学',
                    pathUrl: ''
                },
                {
                    url: '../../../static/logo/logo6.png',
                    schoolName: '河北地质大学',
                    pathUrl: 'https://www.hgu.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo7.png',
                    schoolName: '湖北大学知行学院',
                    pathUrl: 'https://www.hudazx.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo8.png',
                    schoolName: '三峡大学科技学院',
                    pathUrl: 'https://kjxy.ctgu.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo9.png',
                    schoolName: '湖北工业大学工程技术学院',
                    pathUrl: 'https://gcxy.hbut.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo10.png',
                    schoolName: '商丘工学院',
                    pathUrl: 'https://www.sqgxy.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo11.png',
                    schoolName: '开封大学',
                    pathUrl: 'https://www.kfu.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo12.png',
                    schoolName: '武汉工程职业技术学院',
                    pathUrl: 'https://www.wgxy.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo13.png',
                    schoolName: '南京科技职业学院',
                    pathUrl: 'https://www.njpi.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo14.png',
                    schoolName: '武汉船舶职业技术学院',
                    pathUrl: 'https://www.wspc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo15.png',
                    schoolName: '武汉城市学院',
                    pathUrl: ''
                },
                {
                    url: '../../../static/logo/logo16.png',
                    schoolName: '湖北交通职业技术学院',
                    pathUrl: 'https://www.hbctc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo17.png',
                    schoolName: '湖北生态工程职业技术学院',
                    pathUrl: 'https://www.hb-green.com/'
                },
                {
                    url: '../../../static/logo/logo18.png',
                    schoolName: '益阳职业技术学院',
                    pathUrl: 'http://yyvtczs.jysd.com/'
                },
                {
                    url: '../../../static/logo/logo19.png',
                    schoolName: '武汉交通职业学院',
                    pathUrl: 'https://www.whtcc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo20.png',
                    schoolName: '武汉软件工程职业学院',
                    pathUrl: 'https://www.whvcse.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo21.png',
                    schoolName: '湖北三峡职业技术学院',
                    pathUrl: 'https://www.tgc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo22.png',
                    schoolName: '湖北商贸学院',
                    pathUrl: 'https://www.hbc.edu.cn/index.htm'
                },
                {
                    url: '../../../static/logo/logo23.png',
                    schoolName: '湖北科技职业学院',
                    pathUrl: 'https://www.hubstc.com.cn/'
                },
                {
                    url: '../../../static/logo/logo24.png',
                    schoolName: '武汉晴川学院',
                    pathUrl: 'https://www.qcuwh.cn/'
                },
                {
                    url: '../../../static/logo/logo25.png',
                    schoolName: '武汉纺织大学外经贸学院',
                    pathUrl: 'https://www.whcibe.com/'
                },
                {
                    url: '../../../static/logo/logo26.png',
                    schoolName: '黄冈职业技术学院',
                    pathUrl: 'https://www.hgpu.cn/?SessionVerify=72d037f7-ab3e-4078-9569-eb0e78173c2c'
                },
                {
                    url: '../../../static/logo/logo27.png',
                    schoolName: '武汉生物工程学院',
                    pathUrl: 'https://www.whsw.cn/'
                },
                {
                    url: '../../../static/logo/logo28.png',
                    schoolName: '武汉工程科技学院',
                    pathUrl: 'https://www.wuhues.com/'
                },
                {
                    url: '../../../static/logo/logo29.png',
                    schoolName: '武昌职业学院',
                    pathUrl: 'https://www.wczy.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo30.png',
                    schoolName: '中原科技学院',
                    pathUrl: 'https://www.zykj.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo31.png',
                    schoolName: '郑州商学院',
                    pathUrl: 'https://www.zbu.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo32.png',
                    schoolName: '郑州经贸学院',
                    pathUrl: 'https://www.zueb.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo33.png',
                    schoolName: '郑州电子信息职业技术学院',
                    pathUrl: 'https://www.zyfb.com/'
                },
                {
                    url: '../../../static/logo/logo34.png',
                    schoolName: '武汉光谷职业学院',
                    pathUrl: 'https://www.whggvc.net/'
                },
                {
                    url: '../../../static/logo/logo35.png',
                    schoolName: '武汉市第二轻工业学校',
                    pathUrl: 'https://www.wheqx.cn/xxgk/xxjj.htm'
                },
                {
                    url: '../../../static/logo/logo36.png',
                    schoolName: '武汉燃气热力学校',
                    pathUrl: 'https://www.rqrlxx.com/'
                },
                {
                    url: '../../../static/logo/logo37.png',
                    schoolName: '武汉凡谷电子职业技术学校',
                    pathUrl: 'http://www.finguschool.cn/'
                },
                {
                    url: '../../../static/logo/logo38.png',
                    schoolName: '随州机电工程学校',
                    pathUrl: 'https://www.szjd.net.cn/'
                },
                {
                    url: '../../../static/logo/logo39.png',
                    schoolName: '湖北省广播电视学校',
                    pathUrl: 'http://hbbts.com/'
                },
                {
                    url: '../../../static/logo/logo40.png',
                    schoolName: '河南信息工程学校',
                    pathUrl: 'http://hnxxgc.gtjiaoyu.com/'
                },
                {
                    url: '../../../static/logo/logo41.png',
                    schoolName: '河南省驻马店财经学校',
                    pathUrl: 'https://www.zmdcjxx.com.cn/'
                },
                {
                    url: '../../../static/logo/logo42.png',
                    schoolName: '河南省理工学校',
                    pathUrl: 'http://www.hnlg.com.cn/'
                },
                {
                    url: '../../../static/logo/logo43.png',
                    schoolName: '郑州市国防科技学校',
                    pathUrl: 'https://www.zzsgfkjxx.com/'
                },
                {
                    url: '../../../static/logo/logo44.png',
                    schoolName: '武汉市黄陂区职业技术学校',
                    pathUrl: 'http://hpzx.wuhaneduyun.cn/'
                },
                {
                    url: '../../../static/logo/logo45.png',
                    schoolName: '合肥理工学校',
                    pathUrl: 'https://www.hflg.cc/'
                },
                {
                    url: '../../../static/logo/logo46.png',
                    schoolName: '湖北健康职业学院',
                    pathUrl: 'https://www.hbhvc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo47.png',
                    schoolName: '武汉新华电脑学校',
                    pathUrl: 'https://www.whxhdn.com/'
                },
                {
                    url: '../../../static/logo/logo48.png',
                    schoolName: '武汉军需工业技工学校',
                    pathUrl: 'https://www.whjgedu.cn/index.html'
                },
                {
                    url: '../../../static/logo/logo49.png',
                    schoolName: '湖北铁道运输职业学院',
                    pathUrl: 'https://www.hcrt.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo50.png',
                    schoolName: '保定市风帆技工学校',
                    pathUrl: 'http://bdffjx.com/'
                },
                {
                    url: '../../../static/logo/logo51.png',
                    schoolName: '哈尔滨剑桥学院',
                    pathUrl: 'https://www.hcc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo52.png',
                    schoolName: '安徽国防科技职业学院',
                    pathUrl: 'https://www.acdt.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo53.png',
                    schoolName: '孝感市高级技工学校',
                    pathUrl: 'http://xggjjx.com/showpage.asp?id=2'
                },
                {
                    url: '../../../static/logo/logo54.png',
                    schoolName: '武汉市工业科技学校',
                    pathUrl: ''
                },
                {
                    url: '../../../static/logo/logo55.png',
                    schoolName: '武汉航海职业技术学院',
                    pathUrl: 'http://www.whhhxy.com/'
                },
                {
                    url: '../../../static/logo/logo56.png',
                    schoolName: '河南地矿职业学院',
                    pathUrl: 'https://www.hagmc.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo57.png',
                    schoolName: '武汉信息传播职业技术学院',
                    pathUrl: 'https://whinfo.cn/'
                },
                {
                    url: '../../../static/logo/logo58.png',
                    schoolName: '郑州智能科技职业学院',
                    pathUrl: 'https://www.zzcit.edu.cn/'
                },
                {
                    url: '../../../static/logo/logo59.png',
                    schoolName: '湖北新东方烹饪学校',
                    pathUrl: 'https://www.hbxdf.com/zt/xjzc/index.html'
                }
            ]
        }
    },
    methods: {
        enter(url){
         window.open(url, '_blank', 'noopener noreferrer');
        },
        handleMouseEnter(index){
            this.schoolBid = index;
        },

        handleMouseLeave(){
            this.schoolBid = -1;
        }

    },
}
</script>

<style scoped lang="scss">
.partner-institutions {

    .banner-head {
        width: 100%;
        height: 700px;
        background-image: url("../../assets/cooperation_school/banner-head.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;

        .introduction-box {
            width: 1280px;
            text-align: left;
            margin: 0 auto;

            .title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 64px;
                color: #FF6E00;
                line-height: 80px;
                text-align: left;
                font-style: normal;
            }

            .cooperative-text {
                font-family: PingFangSC, PingFang SC;
                font-size: 47px;
                line-height: 80px;
                text-align: left;
                font-style: normal;
            }

            .cooperative-address {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #171A1D;
                line-height: 33px;
                letter-spacing: 2px;
                text-align: left;
                font-style: normal;
            }
        }
    }

    .cooperation-school {
        height: 2676px;
        background: rgba(246, 246, 246, 0.6);
        box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;

        .school-list {
            width: 1280px;
            height: 2516px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: space-between;

            .school-itme-active {
                width: 195px;
                height: 230px;
                border-radius: 16px;
                background: linear-gradient(180deg, rgba(255, 110, 0, 1), rgba(255, 255, 255, 1));
                padding: 0.8px; /* 控制边框的粗细 */
                .school{
                    width: 100%;
                    height: 100%;
                    background: #FFFFFF;
                    border-radius: 16px;
                    display: flex;
                    align-items: flex-end;
                    .school-content{
                        width: 196px;
                        height: 190px;
                        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FF6E00 100%);
                        border-bottom-left-radius: 16px;
                        border-bottom-right-radius: 16px;
                        position: relative;
                        .btn{
                            width: 115px;
                            height: 32px;
                            background: linear-gradient( 171deg, #FFFFFF 0%, #FFF2E7 100%);
                            border-radius: 16px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 14px;
                            color: #FF6E00;
                            line-height: 32px;
                            text-align: center;
                            font-style: normal;
                            position: absolute;
                            left: 42px;
                            bottom: 51px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .school-itme {
                width: 196px;
                height: 230px;
                background: #FFFFFF;
                box-shadow: 0px 2px 8px 0px rgba(225, 225, 225, 0.57);
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .school-name {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    width: 160px;
                    color: #171A1D;
                    line-height: 22px;
                    text-align: center;
                    font-style: normal;
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/partner_institutions/index.vue